import React, { ReactElement } from 'react';
import AppLogoBrand from './AppLogoBrand';

interface Props {
    height?: number;
    width?: number;
    useExtended?: boolean;
}

function AppLogoBrandPostgreSql({
    height = 28,
    width = 89,
    useExtended = true,
}: Props): ReactElement {
    return (
        <AppLogoBrand
            height={height}
            logo={
                useExtended
                    ? 'vendor-postgresql-brand-logo'
                    : 'vendor-postgresql-brand-logo-short'
            }
            size=""
            testId="AppLogoBrandPostgreSql"
            width={width}
        />
    );
}

export default AppLogoBrandPostgreSql;
